module.exports = __webpack_public_path__ + "img/kurt-holman.aaf08992.png";